// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"7c302e82","973":"fa5287c6"}[chunkId] + ".chunk.js";
};